import { useEffect, useState } from "react";

const INTRO_DURATION_MS = 1500;

const prefersReducedMotion = () =>
  typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export const useIntroProgress = (enabled: boolean): number => {
  const [progress, setProgress] = useState(enabled ? 0 : 1);

  useEffect(() => {
    if (!enabled || prefersReducedMotion()) {
      setProgress(1);
      return;
    }

    const startTime = performance.now();
    let animationFrame = 0;

    const animate = (currentTime: number) => {
      const elapsed = Math.min((currentTime - startTime) / INTRO_DURATION_MS, 1);
      setProgress(1 - Math.pow(1 - elapsed, 3));
      if (elapsed < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [enabled]);

  return progress;
};
